import { useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { App as CapApp } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";
import { useAuth } from "@/context/AuthContext";
import { isNative } from "@/lib/native";
import { registerPush } from "@/lib/push";

export const homeFor = (u) => ({ admin: "/admin", candidate: "/candidate" }[u?.role] || "/app");

// Native-only glue: splash, status bar, Android back button, push taps, returning from Stripe.
export const NativeBridge = () => {
  const { user, refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!isNative) return;
    StatusBar.setStyle({ style: Style.Light }).catch(() => {});
    const back = CapApp.addListener("backButton", ({ canGoBack }) => (canGoBack ? window.history.back() : CapApp.exitApp()));
    const done = Browser.addListener("browserFinished", () => refresh());
    return () => { back.then((h) => h.remove()); done.then((h) => h.remove()); };
  }, [refresh]);

  useEffect(() => {
    if (!isNative || user === null) return;
    SplashScreen.hide().catch(() => {});
    if (user) registerPush((path) => nav(path)).catch(() => {});
  }, [user, nav]);

  return null;
};

export const NativeHome = () => {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center" data-testid="native-loading"><Loader2 className="h-6 w-6 animate-spin text-stone-500" /></div>;
  return <Navigate to={user ? homeFor(user) : "/login"} replace />;
};
